import { Suspense } from 'react';

import { fetchGetVerifiedBankAccounts } from '@iwoca/lapi-client/edge';
import { Spinner } from '@iwoca/orion';
import { useQuery } from '@tanstack/react-query';

import { AddNewAccount } from './AddNewAccount/AddNewAccount';
import { SelectVerifiedAccount } from './SelectVerifiedAccount';
import { ErrorBoundary } from '../../../../../errorBoundary/ErrorBoundary';
import { useStateKey } from '../../../../../iwQueryClient/useStateKey';
import FallbackErrorModal from '../../../../modals/fallbackErrorModal/FallbackErrorModal';

const BankDetailsAction = () => {
    const stateKey = useStateKey();
    const { data: verifiedBankAccounts } = useQuery({
        queryKey: ['verified_bank_accounts', stateKey],
        queryFn: () => fetchGetVerifiedBankAccounts({ stateKey: stateKey }),
        suspense: true,
        select: (data) => data.data
    });

    if (!verifiedBankAccounts || verifiedBankAccounts.length === 0) {
        return <AddNewAccount />;
    }

    return (
        <SelectVerifiedAccount verifiedBankAccounts={verifiedBankAccounts} />
    );
};

export const BankDetailsActionDE = () => {
    return (
        <ErrorBoundary fallback={() => <FallbackErrorModal />}>
            <Suspense
                fallback={
                    <Spinner dataTestId="de-bank-details-action-loading" />
                }
            >
                <BankDetailsAction />
            </Suspense>
        </ErrorBoundary>
    );
};
